import React, {useEffect} from 'react';
import { Card, CardBody, CardTitle } from 'reactstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import {connect, useSelector} from 'react-redux'

// components
import TranslateButton from "../../../components/buttons/TranslateButton";
import {ActiveFormatter} from "../../../components/tables/activeFormater";

// labels
import {TT_DELETE, TT_EDIT} from "../../../components/i18n/toolTips";
import {LIST, NO_DATA_FOUND} from "../../../components/i18n/i18n";

// actions

// services
import {afiClassService} from "../../../jwt/_services/hotel/afiClassService";
import {getStateByPath} from "../../../redux/selectors";
import {genericIndexedActions} from "../../../redux/actions/generics/GenericIndexedActions";
import {ModalFormContainer} from "../../../components/confirmAlert/ModalFormContainer";
import {ConfirmDelete} from "../../../components/confirmAlert/ConfirmDelete";
import {setFilter, setForm, setItem, setTableParams} from "../../../redux/actions/generics/IndexedActions";
import AfiClassForm from "./_form";
import {GenericButton} from "../../../components/buttons/customButtons";

const AfiClassList = props => {
    const {path} = props
    const componentState = useSelector(state => getStateByPath(state, path));
    const { app, pageSize, pageIndex, totalSize, listDomainObjects, filter} = componentState?.data || {};
    const fbDataBase = {id: app?.fbDataBase?.id}

    useEffect( () => {
        if(filter || !app?.id)
            return

        props.setFilter(path,{
            fbDataBase,
            onlyRegistered:true,
            item: { code: null }
        })
    }, [app]);

    useEffect(() => {
        if(!filter)
            return

        genericIndexedActions.search(path, afiClassService, pageIndex, pageSize, filter)
    }, [pageIndex, pageSize, filter]);

    const handleTableChange = (type, {page, sizePerPage}) => {
        let currentIndex = (page - 1) * sizePerPage
        props.setTableParams(path, sizePerPage, currentIndex, totalSize, currentIndex )
    };

    const editItem = (data) => {
        props.setItem(path, data);
        props.setForm(path, true, false, false);

        ModalFormContainer(AfiClassForm, { path, data })
    }

    const createItem = () => {
        props.setItem(path, null);
        props.setForm(path)

        ModalFormContainer(AfiClassForm, { path })
    }

    const confirmDelete = (data) => ConfirmDelete({
        path,
        data,
        fbDataBaseId: app?.fbDataBase?.id,
        service: afiClassService,
        remove : genericIndexedActions.delete,
    } );

    const activeFormatter = cell => <ActiveFormatter active={cell} />

    const actionsFormatter = (cell, row) => <>
        <GenericButton style={'table'} toolTip={TT_EDIT} icon={'fa-pen'} permission={'edit'} onClick={() => editItem(row)}/>
        <TranslateButton item={row} service={afiClassService} path={path}/>
        <GenericButton style={'danger-secondary'} toolTip={TT_DELETE} icon={'fa-trash'} permission={'delete'} onClick={() => confirmDelete(row)}/>
    </>

    const columns = [
        {
            dataField: 'id',
            headerStyle: {width: '0px'},
            text: 'ID',
            hidden: true
        }, {
            dataField: 'uid',
            text: 'uid',
            headerStyle: {width: '200px'},
        }, {
            dataField: 'name',
            text: 'Nombre'
        }, {
            dataField: 'status',
            text: "Activo",
            headerAlign: 'center',
            align: 'center',
            headerStyle: {width: '80px'},
            formatter: activeFormatter
        }, {
            dataField: 'actions',
            isDummyField: true,
            text: 'Acción',
            headerAlign: 'center',
            align: 'center',
            headerStyle: {width: '200px'},
            formatter: actionsFormatter
        }
    ];

    return <Card>
        <CardTitle className="bg-light border-bottom p-3 mb-0">
            <i className="far fa-list-alt mr-2"/>{LIST}
            <div className="float-right">
                <GenericButton
                    style={'table'}
                    label={'Agregar'}
                    toolTip={'Agregar'}
                    icon={'fa-plus'}
                    permission={'add'}
                    onClick={createItem}
                />
            </div>
        </CardTitle>

        <CardBody>
            <BootstrapTable
                striped hover
                tableHeaderClass='mb-0'
                remote
                keyField="id"
                data={listDomainObjects || []}
                columns={ columns }
                noDataIndication={NO_DATA_FOUND}
                pagination={paginationFactory({pageIndex, pageSize, totalSize})}
                onTableChange={ handleTableChange }
            />
        </CardBody>
    </Card>
}

const mapStateToProps = state => ({
})

const mapActionsToProps = ({
    setFilter,
    setTableParams,
    setForm,
    setItem,
})

export default connect(mapStateToProps, mapActionsToProps)(AfiClassList)